<single-notification-preview
  [notification]="notification"
  [url]="url"
>
  <div single-notification-preview-text [innerHTML]="notification.preparedText | linkFromText | textBreak | loggedTime | noBrackets"></div>
</single-notification-preview>
